import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-icon-china',
  templateUrl: './icon-china.component.html',
  styleUrls: ['./icon-china.component.scss']
})
export class IconChinaComponent implements OnInit {

  @Input() cssClass = 'icon--18';
  
  constructor() { }

  ngOnInit() {
  }

}
